export interface Citizens {
  id: string;
}


export interface CitizensInput {
  userNidaNumber?: string;
  userLastName?: string;
  userFirstName?: string;
  userEmail?: string;
  profilePhone?: string;
  passportNumber?: string;
  userPassword?:string;
  citizenType?: CitizenTypeInum
}

export enum CitizenTypeInum {
  Local = "Local",
  Foreigner = "Foreigner"
}
